"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PortfolioFilterModel = /** @class */ (function () {
    function PortfolioFilterModel(categorySystemName, filterFields, filterWithData) {
        this._filterWithData = {};
        this._categorySystemName = categorySystemName;
        this._filterFields = filterFields;
        this._filterWithData = filterWithData;
    }
    return PortfolioFilterModel;
}());
exports.PortfolioFilterModel = PortfolioFilterModel;
//# sourceMappingURL=filter.model.js.map